<template>
  <div>
    <div id="mySidenav" class="sidenav">
      <base-button
        class="subtitle bg-gradient-success calcGeneralValueGoals"
        id="goal"
        style="border-radius: 12px; border: 0;"
      >
        <div v-if="isLoadingTotalValues">
          Calculando...
        </div>
        <div v-else>
          <p class="label">META FINANCEIRA</p>

          {{
            (totalValues.meta_financeira || 0).toLocaleString("pt-BR", {
              style: "currency",
              currency: "brl",
            })
          }}
          <div v-if="typeof totalValues.meta_fornecedor !== 'undefined'">
            <p class="label">META FORNECEDOR</p>
            <p class="value">
              {{
                (totalValues.meta_fornecedor || 0).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </p>
          </div>
          <div v-for="(grupo, index) in totalValues" :key="index">
            <hr
              v-if="index !== 'meta_financeira' && index !== 'meta_fornecedor'"
            />
            <p
              v-if="index !== 'meta_financeira' && index !== 'meta_fornecedor'"
              class="label"
            >
              {{ index }}
            </p>
            <p
              v-if="index !== 'meta_financeira' && index !== 'meta_fornecedor'"
              class="value"
            >
              {{
                grupo.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </p>
          </div>
        </div>
      </base-button>
    </div>
    <div class="container">
      <div class="d-flex justify-content-between">
        <PageTitle
          class="mr-2"
          icon="fas fa-table"
          main="Cadastro"
          sub="Metas de balcão e redistribuição"
          :help="true"
          titleHelp="Ajuda - Metas"
          content="Responsável por cadastrar metas de venda em determinado Ano Safra.
  O sistema traz as marcas e dentro de cada marca é possível visualizar os produtos preferenciais vinculados a essa marca.
  Para cadastro/alteração no volume da meta é necessário abrir uma marca, escolher o produto preferencial e alterar o volume e/ou volume estratégico."
        />
        <div class="d-flex justify-content-end">
          <el-tooltip
            :enterable="false"
            placement="top"
            content="Atualizar o grupo das metas para o grupo atual dos produtos."
          >
            <base-button
              type="neutral"
              size="sm"
              class="mt-4 mb-2 mr-2"
              style="height: fit-content;"
              @click="modals.groupUpdate = true"
            >
              Atualizar Grupos Das Metas
          </base-button>
        </el-tooltip>
        <el-tooltip
          :enterable="false"
          placement="top"
          content="Transferir metas entre vendedores."
          v-if="$currentUser().is_admin"
        >
          <base-button
            type="secondary"
            class="mt-4 mb-2"
            style="height: fit-content;"
            @click="modals.transferUpdate = true"
          >
            Transferir metas
          </base-button>
        </el-tooltip>
        <el-tooltip
          :enterable="false"
          placement="top"
          content="Atualizar o cálculo de um ou mais produtos no valor da meta"
        >
          <base-button
            type="secondary"
            class="mt-4 mb-2 ml-2"
            style="height: fit-content;"
            @click="modals.updateGoals = true"
            >
              Atualizar Produtos
            </base-button>
          </el-tooltip>
        </div>
      </div>
      <!-- Filters -->
      <card type="frame">
        <filter-goals
          :anosafra.sync="anosafra"
          :brands="products_brands"
          :selectedSalesmanJob.sync="selectedSalesmanJob"
          :getBrands="getBrands"  
          @update:elabled-salesman-goals="enableSalesmanGoals = $event"   
          @salesman="
            getProducts($event);
            selectedSalesman = $event;
            cleanBrands();
          "
          @filter="search"
        />
      </card>

      <goal-transfer-modal :show.sync="modals.transferUpdate" />

      <modal :show.sync="modals.groupUpdate" size="sm">
        <template slot="header">
          <div class="row">
            <h6 class="modal-title col-12 ml-3 mb--3">
              Atualizar Grupos
            </h6>
          </div>
        </template>

        <anosafra-multiselect
          v-model="groupUpdateAnosafra"
          label="Ano Safra"
        />

        <template slot="footer">
          <base-button type="secondary" @click="modals.groupUpdate = false">Fechar</base-button>
          <base-button type="success" @click="updateGoalsGroup">Continuar</base-button>
        </template>
      
      </modal>
      <div>
        <modal :mouseDownOn="false" @close="resetClientForm" :show.sync="modals.goalsClients" size="xl">
          <template slot="header">
            <div class="row">
              <h6 class="modal-title col-12 ml-2" id="exampleModalLabel">
                Produto:
                <strong>{{ salesmanGoal.name }}</strong>
              </h6>
            </div>
          </template>
          <goals-client-form
            :salesman="selectedSalesman"
            :preferredproduct="selectedPreferredproduct"
            :anosafra="anosafra"
            @save-clicked="saveGoals(selectedPreferredproduct)"
            @save-success="
              modals.goalsClients = false;
              changePage(paginated_brands.current || 0)
            "
            @close="modals.goalsClients = false"
            :key="this.updateGoalsClientsModal"
          />
        </modal>

        <template>
          <modal :show.sync="modals.updateGoals" @close="clearSelectBrand" size="lg">
            <template slot="header">
              <h5 class="modal-title" id="exampleModalLabel">
                Selecione os produtos para atualizar
              </h5>
            </template>
            <div class="row">
              <div class="col-12 col-md-6 mb-6">
                <anosafra-multiselect
                  v-model="selectedAnosafra"
                  label="Ano Safra"
                />
              </div>
              <div class="col-12 col-md-6">
                <label class="form-control-label">Selecionar Marca</label>
                <multiselect
                  v-model="baseBrand"
                  :options="avaliableBrands"
                  placeholder="Selecione uma Marca"
                  label="name"
                  filterable
                  :allow-empty="true"
                  select-label=""
                  deselect-label=""
                  selected-label="Selecionado"
                  track-by="id"
                  @input="searchProductsBrand"
                  :disabled="isDisabledBrand || isDisabled"
                >
                </multiselect>
                <div class="switch-container">
                  <p style="margin-top: 12px; margin-right: 14px;">Selecionar tudo?</p>
                  <base-switch v-model="selectAll" :inactive-label="'Não'" :active-label="'Sim'" label="Sim" class="mr-2" :disabled="loading || isDisabled"></base-switch>
                  <div v-if="loading" class="loading-indicator">Carregando...</div>
                </div>
              </div>
              <div class="col-md-12">
                <vue-list-picker
                  :left-value.sync="listPickerLeftSearchValue"
                  :left-items="paginatedProductsLeft"
                  :right-items="groupedProducts"
                  :content-key="'id'"
                  content-attr="name"
                  title-left="Produtos"
                  title-right="Produtos Selecionados"
                  content-class="itensGrupos"
                  title-class="tituloGrupos"
                  button-class="btn btn-success button-class"
                  :leftSearch="true"
                  @search-action-left="searchProductsName"
                  leftSearchPlaceholder="Escolha um produto"
                  ref="vueListPicker"
                  >
                  <template v-slot:tooltip="{ item }">
                    <p>{{item.name}}</p>
                  </template>
                </vue-list-picker>
              </div>
              <div class="col-md-6">
                <div slot="footer" class="py-4 justify-content-end">
                  <base-pagination
                    v-on:input="changePageLeft"
                    v-model="productsForPaginate['current']"
                    :total="productsForPaginate['count']"
                    :perPage="productsForPaginate['per_page']"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div slot="footer" class="py-4 d-flex justify-content-end">
                  <base-pagination
                    v-on:input="changePageRight"
                    v-model="paginatedProductsRight['current']"
                    :total="paginatedProductsRight['count']"
                    :perPage="paginatedProductsRight['per_page']"
                  />
                </div>
              </div>
            </div>
            <template slot="footer">
              <el-tooltip 
                content="Não é possível atualizar produtos para ano safras fechados" 
                :disabled="!selectedAnosafra || selectedAnosafra.is_open" 
                placement="top"
              >
                <base-button
                  type="primary"
                  :disabled="!selectedAnosafra || !selectedAnosafra.is_open"
                  @click="updateProducts"
                  :loading="isLoadingUpdate"
                  >Concluir</base-button>
              </el-tooltip>
            </template>
          </modal>
        </template>
      </div>
      <!-- Goals Tables -->
      <div class="row">
        <collapse class="col-12" :multipleActive="false" v-loading="isLoading">
          <collapse-item
            v-for="brand in all_brands"
            :key="`${anosafra.id}/${brand.id}/${selectedSalesman.id}`"
          >
            <h4 slot="title" class="mb-0">
              {{ brand.name }} - Quantidade:
              {{ brand.preferredproducts ? brand.preferredproducts.length : 0 | number({minimumFractionDigits: 0, maximumFractionDigits: 2}) }}
              -
              {{ calcGoalsIndex(brand.preferredproducts ? brand.preferredproducts : 0) | currency }}
              (meta parcial)
            </h4>
            <small v-show="checkSalesmanTypeCampo()" class="text-warning">Atenção! Necessário que 80% da meta seja lançada por clientes</small>

            <el-table
              v-loading="isLoading"
              class="table-responsive table-flush"
              header-row-class-name="thead-light"
              :data="brand.preferredproducts"
              style="width: 100%;"
            >
              <el-table-column
                v-slot="{ row }"
                label="Produto"
                class="mb-4"
                min-width="160px"
                prop="name"
                sortable
              >
                <template>
                  <el-popover trigger="hover" placement="top">
                    <div
                      v-loading="isLoadingGoalValues"
                      v-if="
                        (!selectedSalesman || (Object.keys(selectedSalesman).length == 0)) ||
                        (selectedSalesman && Object.keys(selectedSalesman).length > 0 &&
                        selectedSalesmanJob && Object.keys(selectedSalesmanJob).length > 0)
                      "
                    >
                      <p>
                        <strong>{{ previousYearAnosafra(row) }}</strong>
                      </p>
                      <span
                        ><strong>Meta:</strong>
                        {{ previousYearGoal(row) }}</span
                      >
                      <br />
                      <span
                        ><strong>Realizado:</strong>
                        {{ previousYearAccomplished(row) }}</span
                      >
                      <br />
                      <span
                        ><strong>Volume Realizado:</strong>
                        {{ previousYearGoalVolume(row) }}</span
                      >
                      <br />
                    </div>
                    <div v-else>
                      <p>Selecione cargo para visualizar dados do ano safra anterior</p>
                    </div>
                    <div slot="reference" class="name-wrapper">
                      {{ row.name }}
                      <badge
                        type="secondary"
                        size="sm"
                        v-if="row.unity_type || row.salesmanGoal.unity_type"
                      >
                        {{
                          unityVolumeTranslator(
                            canEdit
                              ? row.unity_type || row.salesmanGoal.unity_type
                              : row.salesmanGoal.unity_type || row.unity_type
                          )
                        }}
                      </badge>

                      <badge type="warning" size="sm" v-if="!row.is_frozen">
                        <i class="fas fa-exclamation-triangle"></i>
                        sujeito a variação de preço
                      </badge>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>

              <el-table-column
                label="Valor Un. R$"
                min-width="140px"
                sortable
                v-slot="{ row }"
                v-if="!vegetalSalesman"
              >
                <base-input
                  input-classes="form-control-sm"
                  :value="
                    (row.salesmanGoal.product_value || row.frozen_price || 0).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'brl',
                    })
                  "
                  placeholder="Ex: 1,80"
                  :disabled="true"
                ></base-input>
              </el-table-column>
              <el-table-column
                label="Volume"
                min-width="130px"
                sortable
                v-slot="{ row }"
              >
                <base-input
                  v-if="vegetalSalesman"
                  input-classes="form-control-sm"
                  class="mb-3"
                  :value="Math.round(row.total_volume || 0).toLocaleString('pt-BR')"
                  :disabled="true"
                />
                <base-input
                  v-else
                  input-classes="form-control-sm"
                  mask="integer"
                  v-model="row.salesmanGoal.volume"
                  @input="handleSalesmanGoalInput($event, row)"
                  :min="0"
                  step="0.1"
                  placeholder="Ex: 1,80"
                  :disabled="!canEdit"
                ></base-input>
              </el-table-column>
              <el-table-column
                label="R$"
                min-width="140px"
                sortable
                v-slot="{ row }"
              >
                <base-input
                  input-classes="form-control-sm"
                  class="mb-3"
                  :value="
                    (
                      parseFloat(vegetalSalesman ?
                        row.monetary_total :
                        row.salesmanGoal.valor_meta) || 0
                    ).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'brl',
                    })
                  "
                  :disabled="true"
                />
              </el-table-column>
              <el-table-column
                label="Estratégico"
                width="154px"
                sortable
                v-slot="{ row }"
              >
                <base-input
                  v-if="vegetalSalesman"
                  input-classes="form-control-sm"
                  class="mb-3"
                  type="number"
                  :value="Math.round(row.total_volume_estrategico).toLocaleString('pt-BR')"
                  :disabled="true"
                  :min="0"
                />
                <base-input
                  v-else
                  input-classes="form-control-sm"
                  mask="integer"
                  class="mb-0"
                  placeholder="Ex: 1,80"
                  v-model="row.salesmanGoal.volume_estrategico"
                  @input="
                    row.salesmanGoal.valor_estrategico = parseFloat(calcValue(
                      parseFloat(row.salesmanGoal.product_value || row.frozen_price || 0),
                      parseFloat($event || 0)
                    ).toFixed(3));
                  "
                  :min="0"
                  :disabled="!canEdit"
                />
                <small class="text-danger small-tooltip" v-if="(row.salesmanGoal.volume_estrategico > row.salesmanGoal.volume) && !vegetalSalesman">O estratégico não pode ser maior que o volume total</small>
              </el-table-column>
              <el-table-column
                label="R$"
                min-width="130px"
                sortable
                v-slot="{ row }"
              >
                <base-input
                  input-classes="form-control-sm"
                  class="mb-3"
                  :disabled="true"
                  :value="
                    (
                      parseFloat(vegetalSalesman ?
                        row.monetary_strategic_total :
                        row.salesmanGoal.valor_estrategico) || 0
                    ).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'brl',
                    })
                  "
                />
              </el-table-column>
              <el-table-column
                label="Detalhar"
                min-width="160px"
                v-slot="{ row }"
                class="row justify-content-center pt-0"
                v-if="!vegetalSalesman"
              >
                <el-dropdown
                  trigger="hover"
                  class="dropdown col-4 mb-4 mr-1"
                  style="cursor: pointer;"
                  v-show="fieldSalesman"
                >
                  <span class="btn btn-sm btn-icon-only text-success">
                    <i class="fas fa-ellipsis-v mt-2"></i>
                  </span>
                  <el-dropdown-menu
                    class="dropdown-menu dropdown-menu-arrow show"
                    slot="dropdown"
                  >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent.stop="launchGoalsCustomer(row)"
                      >Lançar metas por cliente
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
                <base-button
                  type="primary"
                  size="sm"
                  class="col-6"
                  :disabled="row.salesmanGoal.volume_estrategico > row.salesmanGoal.volume"
                  :class="{ marginButtonSave: !checkSalesmanTypeCampo() }"
                  style="min-width: 100px;"
                  @click="saveGoals(row);"
                  v-if="showSaveGoalButton"
                >
                  <i v-show="row.salesmanGoal && row.salesmanGoal.id && goalSaved[row.salesmanGoal.id] && !goalSaved[row.salesmanGoal.id].value" class="fas fa-times"></i>
                  <i v-show="row.salesmanGoal && row.salesmanGoal.id && goalSaved[row.salesmanGoal.id] && goalSaved[row.salesmanGoal.id].value"  class="fas fa-check"></i>
                    Salvar
                  </base-button>
                </el-table-column>
            </el-table>
          </collapse-item>
        </collapse>
        <div slot="footer" class="py-4 justify-content-end">
          <base-pagination
            v-on:input="changePage"
            v-model="paginated_brands['current']"
            :total="paginated_brands['count']"
            :perPage="paginated_brands['per_page']"
          ></base-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Popover,
  Tooltip,
} from "element-ui";

import PageTitle from "@/layouts/PageTitle";
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import UserMultiselect from '@/components/Multiselect/user_multiselect.vue';
import AnosafraMultiselect from '@/components/Multiselect/anosafra_multiselect.vue'

import FilterGoals from "./components/FilterGoals";
import GoalsClientForm from "./components/GoalsClientForm";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import VueListPicker from "@/components/Vue-list-picker/VueListPicker";
import GoalTransferModal from "../../components/Goals/GoalTransferModal.vue";

export default {
  components: {
    FilterGoals,
    GoalsClientForm,
    PageTitle,
    Permissions,
    Multiselect,
    AnosafraMultiselect,
    Collapse,
    CollapseItem,
    [Popover.name]: Popover,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Tooltip.name]: Tooltip,
    VueListPicker,
    UserMultiselect,
    GoalTransferModal
  },
  name: "app",
  data() {
    return {
      availableProducts: [],
      isLoading: false,
      isLoadingTotalValues: false,
      isLoadingGoalValues: false,
      isLoadingUpdate: false,
      isLoadingProducts: false,
      lastGetTotalValuesRequest: null,
      lastGetSalesmansRequest: null,
      lastGetPreviousYearAnalyticalGoalDataRequestIndex: null,
      disabledInput: false,
      goalUnit: { value: 1.18 },
      groupedProducts: [],
      filter: {
        name: null,
        id: null,
        salesmans: [],
        anosafra:[],
        salesmanOrigin: [],
        salesmanDestiny: []
      },
      namingProduct: {},
      errors: [],
      groupUpdateAnosafra: {},
      modals: {
        goalsClients: false,
        modal1: false,
        updateGoals: false,
        groupUpdate: false,
        transferUpdate: false,
      },
      selectedPreferredproduct: {},
      selectedSalesmanJob: {},
      data: [],
      products_brands: [],
      filterBrands: null,
      preferredproducts: [],
      avaliableBrands: [],
      baseBrand: {},
      goalsBranch: [],
      goalSaved: {},
      loadGoal: {},
      anosafra: {},
      selectedAnosafra: null,
      anosafras: [],
      paginatedProductsRight: [],
      paginatedProductsLeft: [],
      productsForPaginate: [],
      salesmanGoal: {},
      saldoOpen: [],
      overall: null,
      overallIndividual: null,
      salesmanGoalVolume: null,
      salesmanGoalEstrategico: null,
      salesmanGoalClient: null,
      goal: {},
      paginated_brands: [],
      clients: [],
      salesman_id: null,
      salesman: {},
      salesmans: [],
      salesmansForSelect: [],
      totalValues: {},
      clientsVolume: [],
      fajuta: {},
      nameSearchTimeout: null,
      upperNameSearchTimeout: null,
      updateGoalsClientsModal: 0,
      periods: [],
      goalsClients: [],
      salesmanGoals: [],
      selectedSalesman: {},
      isLoadingClients: false,
      previousYearData: {},
      previousDataTimer: null,
      lastRequestIndex: 0,
      selectAll: false,
      loading: false,
      isDisabledBrand: false,
      isDisabled: false,
      enableSalesmanGoals: true,
      listPickerLeftSearchValue: "",
    };
  },
  async mounted() {
    if (this.$currentUser().is_salesman && !this.$currentUser().is_admin && !this.$currentUser().is_manager && !this.$currentUser().is_coordinator) {
      await this.getSelectSalesman()
    }

    await this.getAnosafras();

    this.getBrandsForSelect();
    this.getProductsForSelect();  
  },
  methods: {
    formatCurrency(value) {
      return parseFloat(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    async handleSalesmanChange(salesman) {
      if (!salesman) {
        this.salesmanGoals = []; 
        return;
      }

      try {
        const response = await this.$http.secured.get(`/api/v1/goals`, {
          params: { user_id: user.id },
        });
        this.salesmanGoals = response.data; 
      } catch (error) {
        console.error("Erro ao carregar metas:", error);
        this.salesmanGoals = [];
      }finally{
        this.isLoading = false;
      }
    },
    async updateGoalsGroup() {
      const result = await swal.fire({
        title: "Tem certeza?",
        text: "Você não poderá desfazer esta ação!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, atualizar!",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
      })

      if (!result.isConfirmed) return

      console.debug("[Goals] updateGoalsGroup");

      try {
        this.modals.groupUpdate = false

        await this.$http.secured.get(`/api/v1/goals/update_groups`, { params: {anosafra_id: this.groupUpdateAnosafra.id} })
      } catch (error) {
        swal.fire({
          title: "Erro!",
          text: `Não foi possível atualizar os grupos ${error}`,
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#dc3545",
        })
      } finally {
      }
    },
    async selectAllBrands() {
      try {
        this.loading = true;
        this.baseBrand = {};
        const allBrands = await this.getAllBrands();

        let allProducts = [];
        allBrands.forEach((brand) => {
          allProducts = allProducts.concat(brand.preferredproducts);
        });

        this.groupedProducts = allProducts;
      } catch (error) {
        console.error("[selectAllBrands] Error selecting all brands", error);
      } finally {
        this.loading = false;
      }
    },
    checkAdminUser() {
      return this.$root.$data.currentUser.is_admin;
    },
    checkSalesmanTypeCampo() {
      if (this.selectedSalesman.salesman_type === 'campo') {
        return true
      } else {
        return false
      }
    },
    async getTotalValues() {
      if (!Object.keys(this.anosafra).length) return;

      this.isLoadingTotalValues = true
      let currentTimestamp = new Date().getTime()
      this.lastGetTotalValuesRequest = currentTimestamp

      let salesman_id = this.selectedSalesman && this.selectedSalesman.id ? this.selectedSalesman.id : this.$currentUser().id
    
      if (this.selectedSalesmanJob && this.selectedSalesmanJob.label == 'Vegetal') {
        salesman_id = 0
      }

      const params = {
        // salesman_goal: true,
        salesman_id: salesman_id || 0, 
        anosafra_id: this.anosafra.id,
        salesman_job: this.selectedSalesmanJob ? this.selectedSalesmanJob.label : null
      };

      try {
        const response = await this.$http.secured.get("/api/v1/totalvalues", {
          params: params,
        });
        if (this.lastGetTotalValuesRequest < currentTimestamp) return
        this.totalValues = response.data;
      } catch (error) {
        this.errors = error.response ? error.response.data : [];
      }

      this.isLoadingTotalValues = false
    },
    async updateProducts() {
      this.isLoadingUpdate = true;
      let preferredProductIds = this.groupedProducts.map((item) => item.id);

      try {
        const response = await this.$http.secured.get("/api/v1/preferredproducts/freeze_prices", {
          params: {
            preferredproduct_ids: preferredProductIds,
            anosafra_id: this.selectedAnosafra.id
          },
        })
        swal.fire({
          title: `Valores Atualizados com Sucesso!`,
          text: `${response.data.message}`,
          buttonsStyling: false,
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: 'Continuar',
          confirmButtonClass: 'btn btn-success ml-2',
          reverseButtons: true
        })
        this.clearField();
        this.deselectBrand();
        this.modals.updateGoals = false;
        this.getProductsForSelect();
        this.getBrands(null, this.filter);
      } catch (error) {
        console.warn("[Goals][updateProducts] API connection error", error)

        const errorMessage = (error.response && error.response.data && error.response.data.errors) 
                         ? error.response.data.errors 
                        : 'Ocorreu um erro desconhecido, tente novamente mais tarde.';
        
        swal.fire({
          title: 'Erro ao atualizar valores!',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'Ok',
          confirmButtonClass: 'btn btn-danger ml-2',
          reverseButtons: true
        });
      }
      this.isLoadingUpdate = false;
    },
    async getSelectSalesman() {
      try {
        const response = await this.$http.secured.get(`/api/v1/getsalesmans`, {
          params: {
            name_only: true,
            id: this.$currentUser().id
          },
        });
        this.selectedSalesman = response.data;
      } catch (error) {
        console.error("[Goals][getSelectedSalesman]", error)
      }
    },
    async getAnosafras() {
      try {
        const response = await this.$http.secured.get(`/api/v1/anosafras`);

        this.anosafras = response.data.anosafras || [];
        this.anosafra = this.$store.state.currentAnosafra;

        if (
          !(this.anosafra && Object.keys(this.anosafra).length)
        ) {
          this.anosafra = this.anosafras[0];
        }

        this.selectedAnosafra = this.anosafra;
      } catch (error) {
        this.setError(error, "Cannot get Ano Safra");
      }
    },
    changePageRight(page) {},
    filterByProducts(preferredproduct_name) {
      for (const key in this.products_brands) {
        let filtro = this.products_brands[key].preferredproducts;
        this.products_brands[key].preferredproducts = filtro.filter(
          (preferredproduct) => {
            return !!preferredproduct.name.match(
              preferredproduct_name.toUpperCase()
            );
          }
        );
      }
    },
    handleSalesmanGoalInput(event, row) {
      const productValue = parseFloat(row.salesmanGoal.product_value || row.frozen_price || 0);
      const parsedEvent = parseFloat(event || 0);

      row.salesmanGoal.valor_meta = parseFloat(this.calcValue(productValue, parsedEvent).toFixed(3));

      if (!event) {
        row.salesmanGoal.volume_estrategico = '';
      }
    },
    searchProductsName(name) {
      this.listPickerLeftSearchValue = name

      const filter = { ...filter }
      if (name && name.length) filter.name = name

      if (this.nameSearchTimeout) clearTimeout(this.nameSearchTimeout);

      this.nameSearchTimeout = setTimeout(
        () => this.getProductsFiltered(null, { name: filter.name }),
        500
      );
    },
    searchProductsBrand(brand) {
      if(!brand){
        this.clearSelectBrand();
      } else {
        this.getProductsFiltered();
      }
    },
    deselectBrand() {
      this.baseBrand = {};
      this.getProductsForSelect();
    },
    getProductsForSelect(page) {
      this.isLoadingProducts = true;
      let data = { brand_id: this.baseBrand.id };
      return this.$http.secured
        .get("/api/v1/preferredproducts", {
          params: {
            q: data,
            page: page,
            inactivated_at: "nil",
            anosafra_id: this.selectedAnosafra.id,
            salesman_id: this.selectedSalesman.id,
            update: true,
          },
        })
        .then((response) => {
          this.productsForPaginate = response.data || [];
          this.paginatedProductsLeft =
            this.productsForPaginate["preferredproducts"] || [];
          this.isLoadingProducts = false;
        });
    },
    getProductsFiltered(page, params) {
      this.isLoadingProducts = true;
      let data = { ...params, brand_id: this.baseBrand.id };
      return this.$http.secured
        .get("/api/v1/preferredproducts", {
          params: {
            q: data,
            page: page,
            inactivated_at: "nil",
            anosafra_id: this.selectedAnosafra.id,
            salesman_id: this.selectedSalesman.id,
            brand_id: this.baseBrand.id,
          },
        })
        .then((response) => {
          this.productsForPaginate = response.data || [];
          this.paginatedProductsLeft =
            this.productsForPaginate["preferredproducts"] || [];
          this.isLoadingProducts = false;
        });
    },
    changePage(page) {
      this.getBrands(page, this.filter);
    },
    changePageLeft(page) {
      if (this.baseBrand == null) {
        this.getProductsForSelect(page, this.filter);
      } else {
        this.getProductsFiltered(page, this.filter);
      }
    },
    async saveGoals(preferredproduct) {
      const goal = preferredproduct.salesmanGoal

      try {
        const response = await this.$http.secured.put(`/api/v1/goals/${goal.id}`, goal);

        this.$set(goal, 'valor_meta', response.data.valor_meta);
        this.$set(goal, 'valor_estrategico', response.data.valor_estrategico);

        this.loadGoal[goal.id] = { value: false }
        this.$set(this.goalSaved, goal.id, { value: true })
        this.calcValue(response.unitary_price, response.volume)
        this.$toasted.global.defaultSuccess({msg: "Meta atualizada com sucesso!"});
      } catch (error) {
        this.$set(this.goalSaved, goal.id, { value: false })
        console.error('Não foi possivel atualizar meta: ', error);
      }
      
      this.getTotalValues();
    },
    reloadGoal(goal) {
      this.$http.secured
        .get("/api/v1/goals", {
          params: {
            update: true,
            goal_id: goal.salesmanGoal.id,
            preferredproduct_id: goal.id,
          },
        })
        .then((response) => {
          goal = response.data.preferredproducts;
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    reloadBrand(brand) {
      this.$http.secured
        .get("/api/v1/goals", {
          params: {
            update: true,
            brand_id: brand.id,
          },
        })
        .then((response) => {
          goal = response.data.preferredproducts;
        })
        .catch((error) =>
          this.$toasted.global.defaultSuccess({
            msg: error.response.data.errors[0],
          })
        );
    },
    clearField() {
      this.baseBrand = {};
      this.groupedProducts = [];
      this.filterBrands = [];
    },
    getProducts(salesman) {
      if (typeof this.anosafra.id == "undefined") return
      salesman = salesman || this.$currentUser();
      // this.isLoading = true;
      if (typeof salesman === "undefined")
        salesman = this.$root.$data.currentUser.id;

      this.salesman_id = salesman.id;
      this.salesman = salesman;
      this.$nextTick(() => {
        this.getTotalValues();
      });
    },
    async getAllBrands() {
      try {
        const response = await this.$http.secured.get("/api/v1/brands", {
          params: {
            per_page: this.paginated_brands.count,
            goals: true,
            id: this.$currentUser().id,
            anosafra_id: this.anosafra.id,
            salesman_id: this.selectedSalesman.id || this.$currentUser().id,
            preferredproduct_required: true,
          },
        });
        return response.data.brands || [];
      } catch (error) {
        console.error("[selectAllBrands] Error fetching all brands", error);
        return [];
      }
    },
    getBrands(page, q) {
      if (!this.enableSalesmanGoals) return
      if (!this.anosafra.id) return;
      if (q == null) return;

      this.lastRequestIndex += 1;
      const requestIndex = this.lastRequestIndex;
      this.isLoading = true;

      let salesman_id = this.selectedSalesman.id

      if (!this.selectedSalesman.id) {
        salesman_id = this.$currentUser().id
      }

      if (this.selectedSalesmanJob && this.selectedSalesmanJob.label == 'Vegetal') {
        salesman_id = 0
      }

      console.debug('[Goals][getBrands]Current User', this.$currentUser())

      for (let key in q) {
          if (q[key] === null) {
            delete q[key];
          }
      }

      this.$http.secured
        .get("/api/v1/brands", {
          params: {
            page: page,
            q: q,
            id: q.id,
            goals: true,
            anosafra_id: this.anosafra.id,
            salesman_id: salesman_id,
            preferredproduct_required: true,
          },
        })
        .then((response) => {
          if(requestIndex != this.lastRequestIndex) return;

          console.debug("[Goal][getBrands] Atualizando dados com resposta da requisção nº", requestIndex, "\nrequisição atual:", this.lastRequestIndex)

          this.paginated_brands = response.data;
          this.products_brands = this.paginated_brands["brands"];
          this.products_brands = this.products_brands.filter(
            (brand) => brand.preferredproducts.length > 0
          );

          this.filterBrands = this.products_brands;

          if (q.preferredproduct_name) {
            this.filterByProducts(q.preferredproduct_name);
            this.filterBrands = this.products_brands;
          }

          // Sorting preferredproducts
          this.products_brands.forEach((brand) =>
            brand.preferredproducts.sort((a, b) =>
              (a.name || "").localeCompare(b.name || "")
            )
          );
          this.isLoading = false;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    cleanBrands() {
      this.paginated_brands= [];
      this.products_brands = [];
      this.filterBrands = [];
    },
    objectHasNullValues(obj) {
      for (let key in obj) if (obj[key] == null) return true;
      return false;
    },
    getBrandsForSelect() {
      this.$http.secured
        .get("/api/v1/brands", { params: { unpaged: true, goals: true } })
        .then((response) => (this.avaliableBrands = response.data));
    },
    search(data) {
      if (!data) return

      let q = {};
      for (const key in data) {
        if (data[key]) {
          if (key !== "preferredproduct_name") {
            q[key] = data[key].id;
          } else {
            if (data[key] !== "") q[key] = data[key];
          }
        } else if (key == "id") {
          this.filterBrands = null;
        }
      }
      if (Object.keys(q)) this.filter = q;
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },

    viewDetail(salesmanGoal) {
      this.salesmanGoalVolume = salesmanGoal.salesmanGoal.volume;
      this.salesmanGoalEstrategico =
        salesmanGoal.salesmanGoal.volume_estrategico;
      this.disabledInput = true;
      this.modals.modal1 = true;
    },

    launchGoalsCustomer(preferredproduct) {
      this.selectedPreferredproduct = structuredClone(preferredproduct);
      this.salesmanGoal = preferredproduct;

      this.salesmanGoalClient = preferredproduct.salesmanGoal.volume;
      this.updateGoalsClientsModal += 1
      this.modals.goalsClients = true;
    },
    /** Meta parcial */
    calcGoalsIndex(brandPreferredproducts) {
      if (brandPreferredproducts != 0) {
        let total = brandPreferredproducts.reduce(
          (sum, product) => sum + (
            (this.vegetalSalesman ?
              product.monetary_total :
              product.salesmanGoal.valor_meta
            ) || 0),
          0
        );
        return total;
      }
      return 0;
    },
    /** Calcular Volume */
    calcSaldoOpen(goalsBranch) {
      if (goalsBranch != 0) {
        let total = goalsBranch.reduce(
          (sum, total) => sum + total.salesmanGoal.volume,
          0
        );
        return total;
      }
      return 0;
    },

    /** inserção geral de porcentagem */
    overallGoal() {
      let saldoInput = this.saldoOpen;
      this.saldoOpen.forEach((element) => {});
      saldoInput = (this.overall * 10) / 100;
      return saldoInput;
    },

    /** Meta financeira(Total) */
    calcGeneralValuesGoals(goalsBranch, brand) {
      let totalGoals = goalsBranch.reduce(
        (sum, brand) =>
          sum +
          this.calcGoalsIndex(brand.salesmanGoal.volume * this.goalUnit.value),
        0
      );
      return totalGoals;
    },
    approve() {
      let status = "approved";
      this.confirmDecision(status, this.updateStatus);
    },
    disapprove() {
      this.cancel(this.updateStatus);
    },
    vegetalGoal: function () {
      return this.salesman_id === 0;
    },
    cancel(callback) {
      swal
        .queue([
          {
            title: "Tem Certeza?",
            text: "O Vendedor será notificado da sua decisão!",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Tenho Certeza!",
            showClass: {
              popup: "swal2-noanimation",
              backdrop: "swal2-noanimation",
            },
            preConfirm: () => {
              swal.insertQueueStep({
                input: "textarea",
                inputPlaceholder: "Motivar Canvelamento...",
                inputAttributes: {
                  "aria-label": "Motivar Cancelamento",
                },
                showClass: {
                  popup: "swal2-noanimation",
                  backdrop: "swal2-noanimation",
                },
                inputValidator: (value) => {
                  if (!value) {
                    return "A Motivação é obrigatória!";
                  }
                },
                showCancelButton: true,
              });
            },
          },
        ])
        .then((value) => {
          if (!value["dismiss"]) {
            let valueArray = value["value"];
            callback("disapproved", {
              disapproval_justification: valueArray[valueArray.length - 1],
            });
          }
        });
    },
    confirmDecision(status, callback) {
      swal
        .fire({
          title: "Tem Certeza?",
          text: "O Vendedor será notificado da sua decisão!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Tenho Certeza!",
        })
        .then((result) => {
          if (result.value) {
            callback(status);
          }
        });
    },
    updateStatus(status, options = {}) {
      let params = {
        anosafra_user: {
          status: status,
        },
        salesman_id: this.salesman_id,
        manager_id: this.$root.$data.currentUser.id,
      };
      params["anosafra_user"] = Object.assign(params["anosafra_user"], options);

      this.$http.secured
        .patch(`/api/v1/anosafra_user/update_status`, params)
        .then((response) => {
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot save Status");
        });
    },
    async getPreviousYearAnalyticalGoalData(anosafra, salesman) {
      if (salesman && salesman.id && (!this.selectedSalesmanJob || !this.selectedSalesmanJob.value)) {
        return
      }

      this.isLoadingGoalValues = true;
      let currentRequestIndex = (this.lastGetPreviousYearAnalyticalGoalDataRequestIndex || 0) + 1
      this.lastGetPreviousYearAnalyticalGoalDataRequestIndex = currentRequestIndex

      if(!salesman.id) {
        salesman = this.$currentUser()
      }

      if (!anosafra.id || !salesman.id || salesman.id == 0) {
        this.isLoadingGoalValues = false;
        return;
      }

      let params = {
        anosafra_id: anosafra.id,
        previous_anosafra: true,
      }

      if (this.selectedSalesmanJob && this.selectedSalesmanJob.value) {
        switch (this.selectedSalesmanJob.value) {
          case 'admin': // vegetal
            break;
          case 'mkt': // gerente de mkt
            params.mkt_manager_id = salesman.id
            break;
          case 'coordinator': // coordenador
            params.coordinated_id = salesman.id
            break;
          case 'manager': // gestor
            params.manager_id = salesman.id
            break;
          case 'salesman': // vendedor
            params.user_id = salesman.id
            break;
        }
      }

      try {
        console.debug("[Goals][getPreviousYearAnalyticalGoalData] Getting previous year data", params)
        const response = await this.$http.secured.get("/api/v1/report/analytical_goals", { params: params })

        if (this.lastGetPreviousYearAnalyticalGoalDataRequestIndex != currentRequestIndex) {
          return;
        }

        this.previousYearData = {};
        Object.values(response.data)
              .flat()
              .forEach(goal => this.previousYearData[goal.preferredproduct_id] = goal)
      } catch (error) {
        console.error("[Goals][getPreviousYearAnalyticalGoalData] Error getting previous year data", error)
      }
      this.isLoadingGoalValues = false;
    },
    previousYearAnalyticalGoal(product) {
      return this.previousYearData[product.id];
    },
    previousYearGoal(product) {
      let data = this.previousYearAnalyticalGoal(product);

      if (!data) return 0;
      return data.goal_volume.toLocaleString("pt-BR", {
        maximumFractionDigits: 2,
      });
    },
    previousYearAccomplished(product) {
      let data = this.previousYearAnalyticalGoal(product);
      if (!data) return 0;

      return data.currency_completed.toLocaleString("pt-BR", {
        style: "currency",
        currency: "brl",
      });
    },
    previousYearGoalVolume(product) {
      let data = this.previousYearAnalyticalGoal(product);
      if (!data) return 0;

      return data.completed_volume.toLocaleString("pt-BR", {
        maximumFractionDigits: 2,
      });
    },
    previousYearAnosafra(product) {
      let data = this.previousYearAnalyticalGoal(product);
      if (!data) return "SAFRA 0000/0000";

      return data.anosafra.descricao;
    },
    calcValue(unitaryValue, volume) {
      return (unitaryValue || 0) * (volume || 0);
    },
    unityVolumeTranslator(unity) {
      if (!unity) return "Não Definido";

      if (["K", "GL", "SC", "FR", "LT", "KG", "L", "BD"].includes(unity.toUpperCase())) return "KG/LT";
      if (unity.toUpperCase() == "D") return "DOSE";
      if (unity.toUpperCase() == "M") return "MX";
      if (["U", "UN"].includes(unity.toUpperCase())) return "UNIDADE";
      
      return "Não Definido";
    },
    clearSelectBrand() {
      this.baseBrand = {};
      this.groupedProducts = [];
      this.paginatedProductsLeft = [];
      this.selectedAnosafra = this.anosafra;
      this.listPickerLeftSearchValue = '';
    },
    resetClientForm() {
      this.selectedPreferredproduct.salesmanGoal.volume_estrategico = 0;
      this.selectedPreferredproduct.salesmanGoal.volume = 0;
    },
  },
  computed: {
    fieldSalesman: function () {
      if (!this.selectedSalesman) return false;

      return this.selectedSalesman.salesman_type === 'campo';
    },
    postData: function () {
      return {
        brand: {
          name: this.namingProduct.name,
          product_ids: this.groupedProducts.map((el) => {
            return el.id;
          }),
          brand_type: "commercial",
        },
      };
    },
    groups: {
      get() {
        return this.grupos;
      },
      set(val) {
        this.grupos = val;
      },
    },
    all_brands: {
      get() {
        return this.filterBrands ? this.filterBrands : this.products_brands;
      },
      set(val) {
        val ? (this.filterBrands = [{ ...val }]) : (this.filterBrands = val);
      },
    },
    calcPercent: {
      get() {
        return this.overall;
      },
      set(val) {
        this.overall = val;
        this.overallGoal();
      },
    },
    vegetalSalesman: function () {
      return this.selectedSalesman.id == 0;
    },
    showSaveGoalButton() {
      if (this.selectedSalesman.clients_count == 0)
        return true;

      if (this.selectedSalesman.salesman_type === 'balcao')
        return true;

      if (this.selectedSalesman.salesman_type === 'redistribuicao')
        return true;

      return false;
    },
    canEdit() {
      if (this.selectedSalesman.clients_count > 0 && !this.$currentUser().is_admin) return false
      if (this.checkSalesmanTypeCampo()) return false

      return this.anosafra && this.anosafra.is_open;
    },
  },
  watch: {
    selectAll: function(newValue) {
      if (newValue) {
        this.selectAllBrands();
        this.isDisabledBrand = true;
        this.paginatedProductsLeft = {};
      } else {
        this.baseBrand = {};
        this.groupedProducts = {};
        this.isDisabledBrand = false;
      }
    },
    filter: {
      handler(val) {
        this.$emit("filter", val);
      },
      deep: true,
    },
    anosafra(val) {
      this.isLoading = true
      // this.getBrands(null, this.filter)
      this.getTotalValues();
      this.getPreviousYearAnalyticalGoalData(val, this.selectedSalesman || this.salesman);
      this.isLoading = false
    },
    selectedAnosafra(val) {
      if (!val) {
        this.selectedAnosafra = this.anosafra
        this.clearSelectBrand();
        this.selectAll = false;
        this.isDisabled = true;  
      } else {
        this.getPreviousYearAnalyticalGoalData(val, this.selectedSalesman);
        this.getProductsForSelect();
        this.isDisabled = false;
      }
    },
    selectedSalesman: function (val) {
      if (val) {
        console.log("[Goals][Goals] selected Salesman: ", val)
        console.log("[Goals][Goals] selected Salesman salesman_type: ", val.salesman_type)

        this.getPreviousYearAnalyticalGoalData(this.anosafra, val);
      }
    },
    selectedSalesmanJob: function (val) {
      if (this.selectedSalesman) {
        this.getPreviousYearAnalyticalGoalData(this.anosafra, this.selectedSalesman);
        this.getTotalValues();
      }
    },
  },
};
</script>

<style lang="scss">
#mySidenav .subtitle {
  position: fixed;
  top: 90px;
  right: -10px;
  transition: right 0.3s linear, font-size 0.3s linear, width 0.3s linear;
  z-index: 1;
  font-size: 12px;

  &:hover {
    font-size: 18px;

    .label {
      height: 20px;
      width: 150px;
    }
    .value {
      height: 20px;
      width: 150px;
    }

    hr {
      display: block;
      margin-top: 0.5em;
      margin-bottom: 0.5em;
    }
  }

  .label {
    height: 0px;
    width: 0px;
    overflow: hidden;
    margin: 0 auto;
    transition: height 0.3s linear, width 0.3s linear;
  }
  .value {
    font-weight: 600;
    height: 0px;
    width: 0px;
    overflow: hidden;
    margin: 0 auto;
    transition: height 0.3s linear, width 0.3s linear;
  }

  hr {
    display: none;
    margin-top: 0em;
    margin-bottom: 0em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
  }
}

.switch-container {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

@media (max-width: 768px) {
  #mySidenav .subtitle {
    display: none;
  }
}

.solid-vl {
  border-left: 2px solid green;
  height: 178px;
  position: absolute;
  left: 50%;
  margin-left: -3px;
  top: 160px;
}

.list-picker-container {
  border-width: 10px !important;
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
  border-radius: 12px !important;
}

.list-picker-panel {
  border: 1px solid;
  border-color: #ccc;
  border-top: 3px solid;
  border-top-color: #61cf8a;
}
.list-picker-selected {
  background: #61cf8a !important;
}

.tituloGrupos {
  background-color: #61cf8a !important;
  box-sizing: border-box !important;
  color: rgb(255, 255, 255) !important;
  display: inline-block !important;
  font-family: Roboto, sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  height: 30px !important;
  line-height: 17px !important;
  padding-bottom: 4px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 7px !important;
  text-align: left !important;
  text-size-adjust: 100% !important;
  visibility: visible !important;
  /* width: 35% !important; */
  border-radius: 6px 6px 0px 0px;
  border-bottom: 0px !important;
}
.inputLeft {
  width: 97%;
}
.inputRight {
  float: right;
  width: 89%;
}
.button-class {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
  margin-bottom: 10px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  min-width: 50% !important;
}

.button-class img {
  filter: invert(100%);
}

.marginButtonSave {
  margin-bottom: 22px;
  margin-left: 6px;
}
.small-tooltip {
  position:absolute;
  background-color: #f8d7da; 
  border-radius: 4px; 
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); 
  white-space: nowrap; 
  top: 45px
}
.transfer-fields-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  margin-top: 1rem;
}

.transfer-column {
  flex: 1;
  min-width: 0; 
}

</style>
